export const toInputValue = (value: string | Date | null | undefined) => {
  if (!value) return ""

  const date = value instanceof Date ? value : new Date(value)

  if (Number.isNaN(date.getTime())) return ""

  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000)

  return local.toISOString().slice(0, 16)
}

export const roundUpToQuarter = (value: string | Date | null | undefined) => {
  if (!value) return ""

  const date = value instanceof Date ? value : new Date(value)

  if (Number.isNaN(date.getTime())) return ""

  const minutes = date.getMinutes()
  const remainder = minutes % 15

  if (remainder !== 0) {
    date.setMinutes(minutes + (15 - remainder), 0, 0)
  } else {
    date.setSeconds(0, 0)
  }

  return toInputValue(date)
}

export const computeMinDue = (minHours: number, now = new Date()) => {
  const base = new Date(now.getTime())
  base.setHours(base.getHours() + minHours)
  base.setSeconds(0, 0)

  return base
}
